import titleize from '../../utils/titleize';
import { Fragment } from 'preact';
import translations, { DEFAULT_LANG } from '../../translations/i18n';
import widgetConfig from '../../../config';

export const isCityPlace = place =>
  place?.result_type === 'city' || place?.resultType === 'city';

export const isCityAllTerminalsPlace = (place, hybridSearchEnabled = false) =>
  hybridSearchEnabled && isCityPlace(place);

export function getAllTerminalsLabel(lang = widgetConfig.i18nLng) {
  return (
    translations[lang]?.placeholder?.all_terminals ||
    translations[DEFAULT_LANG]?.placeholder?.all_terminals ||
    'All terminals'
  );
}

export function formatCityAllTerminalsDisplay(place, lang) {
  const cityName = place.city_name || place.cityName;
  return `${titleize(cityName)}, ${getAllTerminalsLabel(lang)}`;
}

export function formatCityDisplay(isPackagesSearch, place, lang, hybridSearchEnabled = false) {
  if (isCityAllTerminalsPlace(place, hybridSearchEnabled)) {
    return formatCityAllTerminalsDisplay(place, lang);
  }

  const cityDisplay = isPackagesSearch ? '' : `, ${titleize(place.display)}`;
  return `${titleize(place.city_name)}${cityDisplay}`;
}

export function formatRecentTripCityDisplay(isPackagesSearch, place, lang) {
  if (isCityPlace(place)) return formatCityAllTerminalsDisplay(place, lang);

  return formatCityDisplay(isPackagesSearch, place, lang);
}

export function formatStateDisplay(place) {
  return titleize(`${place.display}, ${place.state}`);
}

export function formatTerminalCityDisplay(place) {
  return titleize(`${place.display}, ${place.city_name}`);
}

export function formatOnlyTerminalDisplay(place) {
  return titleize(place.display);
}

export function formatDisplayType(
  displayType,
  place,
  isPackagesSearch,
  lang,
  hybridSearchEnabled = false
) {
  switch (displayType) {
    case 'city':
    case 'city_state':
      return formatCityDisplay(isPackagesSearch, place, lang, hybridSearchEnabled);

    case 'terminal_city':
      return formatTerminalCityDisplay(place);

    case 'state':
      return formatStateDisplay(place);

    case 'only_terminal':
      return formatOnlyTerminalDisplay(place);

    default:
      return formatStateDisplay(place);
  }
}

export function formatRecommendedDisplayType(place, displayType, hybridSearchEnabled = false) {
  const isRecentSearch = place.recent_search || place.recentSearch;
  const formatted =
    isRecentSearch && isCityPlace(place)
      ? formatCityAllTerminalsDisplay(place)
      : formatDisplayType(displayType, place, false, undefined, hybridSearchEnabled);
  const [primaryLabel, ...secondaryLabelParts] = formatted.split(',');
  const secondaryLabel = secondaryLabelParts.join(',').trim();

  return place.city_name ? (
    <Fragment>
      {primaryLabel}
      {secondaryLabel && (
        <Fragment>
          , <span>{secondaryLabel}</span>
        </Fragment>
      )}
    </Fragment>
  ) : (
    <Fragment>{place.name}</Fragment>
  );
}

export const createPlace = place => ({
  city_name: place.cityName,
  city_slug: place.citySlug,
  display: place.display,
  recent_search: place.recentSearch,
  result_type: place.resultType,
  slug: place.slug,
  state: place.state,
});
